module.exports = __webpack_public_path__ + "static/media/signal-1.4ae20d31.svg";